/* @flow */
import * as React from 'react';
import classnames from 'classnames';
import { type ThemeType } from 'react-css-themr';

import DefaultNavGroupTitle from './DefaultNavGroupTitle';

type Props = {
    source: { id: string },
    selectable: boolean,
    onClick?: (id: string) => void,
    isSelected: boolean,
    isSubSectionSelected: boolean,
    children: React.Node,
    className?: ?string,
    theme: ThemeType,
    testId?: string
};

const defaultSectionFactory = ({
    NavGroupTitle = DefaultNavGroupTitle
}: {
    NavGroupTitle?: React.AbstractComponent<any>
}): React.AbstractComponent<Props> => {
    return class DefaultSection extends React.PureComponent<Props> {
        handleClick = () => {
            const {
                source: { id, custom },
                selectable,
                onClick
            } = this.props;
            if (onClick && selectable) {
                custom ? onClick(custom.data) : onClick(id);
            }
        };

        render() {
            const {
                theme,
                source,
                className,
                children,
                isSelected,
                isSubSectionSelected,
                selectable,
                testId
            } = this.props;
            return (
                <React.Fragment>
                    {source.custom ? (
                        <source.custom.component
                            {...source.custom.data}
                            className={theme.item}
                            onClick={this.handleClick}
                            active={isSelected}
                            testId={testId}
                        />
                    ) : (
                        <div
                            className={classnames(theme.navGroup, {
                                [theme.selectedGroup]:
                                    isSelected || isSubSectionSelected
                            })}
                        >
                            <NavGroupTitle
                                selectable={selectable}
                                source={source}
                                onSectionClick={this.handleClick}
                                className={className}
                                theme={theme}
                                isSelected={isSelected}
                                testId={testId}
                            />
                            <div className={theme.navigation}>{children}</div>
                        </div>
                    )}
                </React.Fragment>
            );
        }
    };
};

const DefaultSection = defaultSectionFactory({});

export { defaultSectionFactory };
export default DefaultSection;
